<template>
  <v-app id="inspire">
    <v-content fill-height fluid grid-list-xl app class="px-1">
      <titulo-responsivo :titulo="locale[local].screen.home.string001" />
      <v-divider />

      <v-row dense>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="6"
          lg="4"
          xl="3"
          v-show="card.showPorCliente"
        >
          <v-card :color="card.color" class="ma-1" @click="redirecionar(card)">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div class="d-flex flex-column justify-space-between">
                <v-card-title
                  class="headline"
                  v-text="card.title"
                  style="
                    color: white;
                    word-break: break-word;
                    text-align: initial;
                  "
                ></v-card-title>
                <div
                  class="pb-5 pl-5 white--text text-left"
                  v-if="card.observacao != ''"
                  v-html="card.observacao"
                ></div>
                <!-- <v-card-subtitle v-text="card.title"></v-card-subtitle> -->
              </div>

              <v-avatar class="ma-3" size="125" tile>
                <v-icon size="128" color="white"> {{ card.icone }} </v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <template v-if="false">
        <h1>{{ locale[local].screen.home.string002 }}</h1>
        <v-divider />

        <v-layout wrap>
          <v-flex md12 sm12 lg4 class="pa-2" style="max-height: 480px">
            <material-chart-card
              :data="grafico2.data"
              :options="grafico2.options"
              color="info"
              type="Line"
            >
              <h4 class="title font-weight-light">
                {{ locale[local].screen.home.string003 }}
              </h4>
              <p class="category d-inline-flex font-weight-light">
                <v-icon color="green" small> mdi-arrow-up </v-icon>
                <span class="green--text">55%</span>&nbsp;
                {{ locale[local].screen.home.string004 }}
              </p>

              <template slot="actions">
                <v-icon class="mr-2" small> mdi-clock-outline </v-icon>
                <span class="caption grey--text font-weight-light">{{
                  locale[local].screen.home.string005
                }}</span>
              </template>
            </material-chart-card>
          </v-flex>
          <v-flex md12 sm12 lg4 class="pa-2" style="max-height: 480px">
            <material-chart-card
              :data="grafico1.data"
              :options="grafico1.options"
              :responsive-options="grafico1.responsiveOptions"
              color="red"
              type="Bar"
            >
              <h4 class="title font-weight-light">Estatísticas</h4>
              <p class="category d-inline-flex font-weight-light">
                {{ locale[local].screen.home.string006 }}
              </p>

              <template slot="actions">
                <v-icon class="mr-2" small> mdi-clock-outline </v-icon>
                <span class="caption grey--text font-weight-light">{{
                  locale[local].screen.home.string007
                }}</span>
              </template>
            </material-chart-card>
          </v-flex>
          <v-flex md12 sm12 lg4 class="pa-2" style="max-height: 480px">
            <material-chart-card
              :data="grafico3.data"
              :options="grafico3.options"
              color="green"
              type="Line"
            >
              <h3 class="title font-weight-light">Demais Estatísticas</h3>
              <p class="category d-inline-flex font-weight-light">
                Alguns dados relevantes
              </p>

              <template slot="actions">
                <v-icon class="mr-2" small> mdi-clock-outline </v-icon>
                <span class="caption grey--text font-weight-light"
                  >Atualizado há 3 dias</span
                >
              </template>
            </material-chart-card>
          </v-flex>
        </v-layout>
        <v-divider />
      </template>
    </v-content>
    <v-snackbar
      v-model="snackbar"
      bottom
      left
      :timeout="8000"
      :vertical="false"
    >
      {{ mensagem }}
      <v-btn color="red" text @click="snackbar = false">OK</v-btn>
    </v-snackbar>
    <v-footer>
      <v-spacer></v-spacer>
      <div class="caption">
        {{ locale[local].screen.home.string008 }} &copy;
        {{ new Date().getFullYear() }} - Versão :
        {{ $store.getters.appVersion }}
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import LoginVue from "./Login";
import Service from "@/components/api/Service";
import { snackbar, alert } from "cids-cgi/lib/util";
import { locale } from "../locale/locale";
import moment from "moment";
export default {
  data: (vm) => ({
    service: new Service(),
    grafico1: {
      data: {
        labels: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ],
        series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]],
      },
      options: {
        axisX: {
          showGrid: false,
        },
        low: 0,
        high: 1000,
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0,
        },
      },
      responsiveOptions: [
        [
          "screen and (max-width: 640px)",
          {
            seriesBarDistance: 5,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value[0];
              },
            },
          },
        ],
      ],
    },
    grafico2: {
      data: {
        labels: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sab", "Dom"],
        series: [[12, 17, 7, 17, 23, 18, 38]],
      },
      options: {
        lineSmooth: vm.$chartist.Interpolation.cardinal({
          tension: 0,
        }),
        low: 0,
        high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
        chartPadding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },
    },
    grafico3: {
      data: {
        labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
        series: [[230, 750, 450, 300, 280, 240, 200, 190]],
      },
      options: {
        lineSmooth: vm.$chartist.Interpolation.cardinal({
          tension: 0,
        }),
        low: 0,
        high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
        chartPadding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },
    },
    cards: [
      {
        rota: "comprovantes",
        title: locale[window.local].screen.home.string009,
        flex: 12,
        color: "#00b297",
        icone: "mdi-cash",
        showPorCliente: process.env.VUE_APP_COMPROVANTES === "true",
      },
      {
        rota: "informesrendimentos",
        title: locale[window.local].screen.home.string010,
        flex: 12,
        color: "#dc3545",
        icone: "mdi-file-document",
        showPorCliente: process.env.VUE_APP_RENDIMENTOS === "true",
      },
      {
        rota: "dadoscadastrais",
        title: locale[window.local].screen.home.string011,
        flex: 12,
        color: "#1D2939",
        icone: "mdi-account-box",
        showPorCliente: true,
      },
      {
        rota: "dependentes",
        title: locale[window.local].screen.home.string012,
        flex: 12,
        color: "#e57b09",
        icone: "mdi-account-plus",
        showPorCliente: true,
      },
      {
        rota: "avisos",
        title: locale[window.local].screen.home.string013,
        flex: 12,
        color: "#0866C6",
        icone: "mdi-bell",
        showPorCliente: true,
      },
      {
        rota: "telefonia",
        title: locale[window.local].screen.home.string014,
        flex: 12,
        color: "green",
        icone: "mdi-phone",
        showPorCliente: process.env.VUE_APP_TELEFONIA === "true",
      },
      {
        rota: "compras-varejo",
        title: locale[window.local].screen.home.string015,
        flex: 12,
        color: "purple",
        icone: "mdi-basket-plus-outline",
        showPorCliente: process.env.VUE_APP_COMPRASVAREJO === "true",
      },
      {
        rota: "pip",
        title: locale[window.local].screen.home.string016,
        flex: 12,
        color: "#00b297",
        icone: "mdi-account-child",
        showPorCliente: process.env.VUE_APP_PIP === "true",
      },
      {
        rota: "espelho-ponto",
        title: locale[window.local].screen.home.string017,
        flex: 12,
        color: "#607D8B",
        icone: "mdi-archive",
        showPorCliente: process.env.VUE_APP_ESPELHO_DO_PONTO === "true",
      },
      {
        rota: "beneficios",
        title: locale[window.local].screen.home.string018,
        flex: 12,
        color: "#1D2939",
        icone: "mdi-gift",
        showPorCliente: process.env.VUE_APP_BENEFICIOS === "true",
      },
      {
        rota: "avaliacao",
        title: locale[window.local].screen.home.string019,
        flex: 12,
        color: "#0866C6",
        icone: "mdi-file-check",
        showPorCliente: true,
        observacao: "",
      },
      {
        rota: "fale-com-rh",
        title: locale[window.local].screen.home.string020,
        flex: 12,
        color: "#FF6D00",
        icone: "mdi-account-voice",
        showPorCliente: true,
      },
      {
        rota: "marcacao-ponto",
        title: locale[window.local].screen.home.string021,
        flex: 12,
        color: "#5E35B1",
        icone: "mdi-bookmark-multiple-outline",
        showPorCliente: process.env.VUE_APP_MARCACOES_DO_PONTO === "true",
      },
      {
        rota: "cartilha",
        title: locale[window.local].screen.home.string023,
        flex: 12,
        color: "#2979FF",
        icone: "mdi-newspaper-check",
        showPorCliente: process.env.VUE_APP_CARTILHA === "true",
      },
      {
        rota: "documentos",
        title: locale[window.local].screen.home.string025,
        flex: 12,
        color: "#E331E6",
        icone: "mdi-draw-pen",
        showPorCliente: process.env.VUE_APP_DOCUMENTOS_ASSINADOS === "true",
        observacao: "",
      },
      {
        rota: "inclusao-ponto",
        title: locale[window.local].screen.home.string026,
        flex: 12,
        color: "#00b297",
        icone: "mdi-clock",
        showPorCliente: process.env.VUE_APP_INCLUSAO_PONTO === "true",
        observacao: "",
      },
      {
        rota: "oportunidade-interna",
        title: locale[window.local].screen.home.string027,
        flex: 12,
        color: "#1444b5",
        icone: "mdi-alert-decagram",
        showPorCliente: process.env.VUE_APP_OPORTUNIDADE_INTERNA === "true",
        observacao: "",
      },
      {
        rota: "reserva-restaurante",
        title: locale[window.local].screen.home.string028,
        flex: 12,
        color: "#00CD66",
        icone: "mdi-silverware-fork-knife",
        showPorCliente: process.env.VUE_APP_RESERVA_RESTAURANTE === "true",
        observacao: "",
      },
      {
        rota: "vale-refeicao",
        title: locale[window.local].screen.home.string029,
        flex: 12,
        color: "#00b297",
        icone: "mdi-silverware-variant",
        showPorCliente: process.env.VUE_APP_VALE_REFEICAO === "true",
      },
      {
        rota: "inclusao-horanaotrab",
        title: locale[window.local].screen.home.string030,
        flex: 12,
        color: "#d4cb24",
        icone: "mdi-clock-remove",
        showPorCliente: process.env.VUE_APP_INCLUSAO_HORANAOTRAB === "true",
        observacao: "",
      }
    ],
    snackbar: false,
    mensagem: "",
    bloqueiaAssinaturaPendente: false,
    mensagemAssinaturaPendente: "",
    bloqueiaAgendaPendente: false,
  }),
  async mounted() {
    this.$root.$emit("atualizarUrlImagem");
    this.$root.$emit("atualizarNomeUsuarioLogado");
    this.$root.$emit("atualizarQuantidadeAvisos");

    const parametros = await this.service.buscaParametro();
    if (parametros.data?.colaborador[0].bloqueiaAssinaturaPend) {
      this.bloqueiaAssinaturaPendente = true;
      this.mensagemAssinaturaPendente =
        parametros.data?.colaborador[0].mensagemAssinaturaPend;
    }

    if (parametros.data?.colaborador[0].bloqueiaAgendaPend) {
      this.bloqueiaAgendaPendente = true;
    }    

    const objAvaliacao = this.cards.find((value) => value.rota === "avaliacao");
    objAvaliacao.observacao =
      parametros.data?.colaborador[0].mensagemQtdeAgenda;

    const objDocumento = this.cards.find(
      (value) => value.rota === "documentos"
    );
    objDocumento.observacao =
      parametros.data?.colaborador[0].mensagemQtdeAssinatura;

    const objOportunidade = this.cards.find(
      (value) => value.rota === "oportunidade-interna"
    );
    objOportunidade.observacao = parametros.data?.colaborador[0].mensagemOportunidade;
    if (parametros.data?.colaborador[0].nomeOportunidade != ""){
      objOportunidade.title = parametros.data?.colaborador[0].nomeOportunidade;
    }

    if (process.env.VUE_APP_VAREJO === "true") {
      const response = await this.service.getStatusVarejo();
      const dtCompetencia = response?.data?.ttPedido[0]?.dtCompetencia ?? "";
      const dtLimiteCompra = response?.data?.ttPedido[0]?.dtLimiteCompra ?? "";
      const hrLimiteCompra = response?.data?.ttPedido[0]?.hrLimiteCompra ?? "";
      const autorizado = response?.data?.ttPedido[0]?.autorizado ?? false;
      let observacao = response?.data?.ttPedido[0]?.observacao ?? "";
      if (autorizado) {
        observacao = `Disponível para ${moment(dtCompetencia).format(
          "MM/YY"
        )} <br> Compras até o dia ${moment(dtLimiteCompra).format(
          "DD/MM/YYYY"
        )} ${moment(hrLimiteCompra).format("HH:mm")}`;
      }
      this.cards.push({
        rota: "varejo",
        title: locale[window.local].screen.home.string022,
        flex: 12,
        color: "#1D2939",
        icone: "mdi-point-of-sale",
        showPorCliente: process.env.VUE_APP_VAREJO === "true",
        autorizado: autorizado,
        observacao: observacao,
      });
    }

    if (process.env.VUE_APP_PROGRAMACAO === "true") {
      let response = await this.service.buscaProgramacaoFerias();
      let obs = "Você não tem Férias Programadas!";

      if (response.length > 0) {
        const dtIniFerias = response[0].dtIniFerias ?? "";
        if (dtIniFerias != "") {
          obs = `Suas próximas férias serão em ${moment(dtIniFerias).format(
            "DD/MM/YYYY"
          )}`;
        }
      }

      this.cards.push({
        rota: "programacao",
        title: locale[window.local].screen.home.string024,
        flex: 12,
        color: "#1DE9B6",
        icone: "mdi-palm-tree",
        showPorCliente: process.env.VUE_APP_PROGRAMACAO === "true",
        observacao: obs,
      });
    }

    const nomeFantasia = process.env.VUE_APP_CLIENTE_FANTASIA;

    if (nomeFantasia === "CGI" || nomeFantasia === "JAN") {
      const codCli = localStorage.getItem("codCli");
      const cpf = localStorage.getItem("cpf");

      const beamsClient = new PusherPushNotifications.Client({
        instanceId: "1e8fd809-724a-4411-b43a-51472ba07f55",
      });
      beamsClient
        .start()
        .then(() => beamsClient.addDeviceInterest(`${codCli}-${cpf}`))
        .then(() => console.log("Successfully registered and subscribed!"))
        .catch(console.error);
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
    async redirecionar(card) {
      try {
        if (this.bloqueiaAssinaturaPendente && card.rota != "documentos") {
          alert.show({ message: this.mensagemAssinaturaPendente });
          return;
        } else 
        if (this.bloqueiaAgendaPendente && card.rota != "avaliacao") {
          alert.show({ message: 'Você tem pesquisa/avaliação pendente!' });
          return;
        }

        if (card.rota === "varejo" && !card.autorizado) {
          snackbar.show({ message: "Não autorizado" });
          return;
        }

        this.$router.push(card.rota);
      } catch (e) {
        snackbar.show({ message: e });
      }
    },

    logout() {
      localStorage.removeItem("codPessoa");
      localStorage.removeItem("codCandidato");
      localStorage.removeItem("cpf");
      localStorage.removeItem("senha");
      localStorage.removeItem("logado");
      this.$emit("home", LoginVue);
    },
  },
  computed: {
    appVersion() {
      return this.$store.getters.appVersion;
    },
  },
};
</script>
